import ManageUsers from '@/components/users/users_manage.vue';
import User from '@/components/users/user.vue';
import UserPassword from '@/components/users/user_change_password.vue';
import UserProfileForm from '@/components/users/user_profile_form.vue';

export default [
  {
    path: '/organisations/:organisationId/users',
    name: 'allUsers',
    component: ManageUsers,
    props: true,
    children: [
      {
        path: ':type',
        name: 'allUsersScoped',
        component: ManageUsers,
        props: true,
      },
    ],
  },
  {
    path: '/organisations/:organisationId/users/new',
    name: 'inviteUser',
    component: User,
    props: true,
  },
  {
    path: '/organisations/:organisationId/operations/:operationId/users',
    name: 'operationUsers',
    component: ManageUsers,
    props: true,
  },
  {
    path: '/organisations/:organisationId/users/:userId/edit',
    name: 'editUser',
    component: User,
    props: true,
  },
  {
    path: '/users/edit',
    name: 'userProfile',
    component: UserProfileForm,
    props: true,
  },
  {
    path: '/users/change_password/edit',
    name: 'userPassword',
    component: UserPassword,
    props: true,
  },
];
